const {
	sm2
} = require('sm-crypto');
const crypto = require('crypto');

// 1. 密钥对生成
// const keypair = sm2.generateKeyPairHex();
const publicKey ="043d8eaa00f6348109f555e240ad2f8c307c4b94afbae43667ea2479f5581aa831f6b14445e5973c8093bb02a1097f76ac687cc477f7d5c8982edfb6b365ca0d5d"; // 公钥
const privateKey = "ccb03f5868b27b310b1e1d37c78b0a7aab814eca0f5785e468fb78ac47405ff0"; // 私钥

// 2. 加密解密
function JMSM2(plainText) {
	if (!plainText) {
		return ""
	}
	if (typeof plainText !== 'string') {
		plainText = plainText.toString();
	}
	return sm2.doEncrypt(plainText, publicKey)
}

function jmSM2(cipherText) {
	if (!cipherText) {
		return ""
	}
	return sm2.doDecrypt(cipherText, privateKey);
}

// 3. 签名验签
function signSM2(message, priKey) {
	const msgHash = crypto.createHash('sm3').update(message).digest('hex');
	return sm2.doSignature(msgHash, priKey);
}

function verifySM2(signature, message, pubKey) {
	const msgHash = crypto.createHash('sm3').update(message).digest('hex');
	return sm2.doVerifySignature(msgHash, signature, pubKey);
}

module.exports = {
	JMSM2,
	jmSM2,
	signSM2,
	verifySM2
};